export default __webpack_public_path__ + "e742f77c95a27820412b2e61b5a68a48.png";